export default __webpack_public_path__ + "static/media/github.ec953731.svg";